import React from "react";
import Joi from "joi-browser";
import Form from "./../common/form";
import * as authService from "../../services/auth";
import withSnackbarWrapper from "../common/withSnackbarWrapper";

class ForgotPassword extends Form {
  state = {
    data: { email: "" },
    errors: {},
    submitted: false,
    passwordReset: false,
  };

  schema = {
    email: Joi.string().required().label("Email"),
  };

  constructor(props) {
    super(props);
    this.resetCode = React.createRef();
    this.newPassword = React.createRef();
    this.confirmNewPassword = React.createRef();
  }

  doSubmit = () => {
    authService
      .forgotPassword(this.state.data)
      .then((response) => {
        if (response.success) {
          this.props.useSnackbarCustom.enqueueSnackbar(response.message, {
            variant: "success",
          });
          this.setState({ submitted: true });
        } else {
          this.props.useSnackbarCustom.enqueueSnackbar(response.message, {
            variant: "warning",
          });
        }
      })
      .catch((err) => {
        console.log("Some error occured.", err);
      });
  };

  resetPassword = (event) => {
    event.preventDefault();

    let data = {};
    data.email = this.state.data.email;
    data.token = this.resetCode.current.value;

    if (data.token === "") {
      return this.props.useSnackbarCustom.enqueueSnackbar(
        "Reset code cannot be empty",
        "warning"
      );
    }

    authService
      .resetPassword(data)
      .then((response) => {
        if (response.success) {
          this.setState({ passwordReset: true });
          //   localStorage.setItem("user", response.data.user);
          //   localStorage.setItem("isCustomer", response.data.isCustomer);
          //   showSuccessToast("Succesfully logged in.");
          //   const { state } = this.props.location;
          //   window.location = state ? state.from.pathname : "/";
        } else {
          this.props.useSnackbarCustom.enqueueSnackbar(response.message, {
            variant: "warning",
          });
        }
      })
      .catch((err) => {
        console.log("Some error occured.", err);
      });
  };

  changePassword = (event) => {
    event.preventDefault();

    let data = {};
    data.email = this.state.data.email;
    data.password = this.newPassword.current.value;
    data.confirmNewPassword = this.confirmNewPassword.current.value;

    let error = "";
    if (data.password !== data.confirmNewPassword)
      error = "Passwords do not match.";
    else if (data.password.length < 5)
      error = "Passwords length should be greater than 5.";

    if (error !== "") {
      return this.props.useSnackbarCustom.enqueueSnackbar(error, "warning");
    }
    delete data.confirmNewPassword;

    authService
      .changePassword(data)
      .then((response) => {
        if (response.success) {
          this.props.useSnackbarCustom.enqueueSnackbar(
            response.success,
            "success"
          );

          setTimeout(() => {
            window.location = "/";
          }, 2000);
        } else {
          this.props.useSnackbarCustom.enqueueSnackbar(
            response.message,
            "warning"
          );
        }
      })
      .catch((err) => {
        console.log("Some error occured.", err);
      });
  };

  render() {
    return (
      <div className="container mt-5">
        <h1>Reset your password</h1>
        {!this.state.submitted && !this.state.passwordReset && (
          <form onSubmit={this.handleSubmit} className="mt-5">
            {this.renderInput("email", "Email", "email")}

            {this.renderButton("Reset password")}
          </form>
        )}

        {this.state.submitted && !this.state.passwordReset && (
          <React.Fragment>
            <form onSubmit={this.resetPassword} className="mt-5">
              <div className="form-group">
                <label htmlFor="resetCode">Password Reset Code</label>
                <input
                  type="text"
                  name="resetCode"
                  id="resetCode"
                  className="form-control form-control-lg"
                  ref={this.resetCode}
                />
              </div>

              <button className="btn btn-lg btn_primary mt-3">Submit</button>
            </form>
          </React.Fragment>
        )}

        {this.state.passwordReset && (
          <React.Fragment>
            <form onSubmit={this.changePassword} className="mt-5">
              <div className="form-group">
                <label htmlFor="newPassword">New password</label>
                <input
                  type="password"
                  name="newPassword"
                  id="newPassword"
                  className="form-control form-control-lg"
                  ref={this.newPassword}
                  autoComplete="false"
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirmNewPassword">Confirm new password</label>
                <input
                  type="password"
                  name="confirmNewPassword"
                  id="confirmNewPassword"
                  className="form-control form-control-lg"
                  ref={this.confirmNewPassword}
                  autoComplete="false"
                />
              </div>

              <button className="btn btn-lg btn_primary mt-3">
                Set new Password
              </button>
            </form>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default withSnackbarWrapper(ForgotPassword);
